<template>
  <div class="dialogtitle">
    <i></i>
    <span>{{ name ? name : "" }}</span>
  </div>
</template>

<script>
export default {
  props: ["name"],
};
</script>

<style lang="scss">
.dialogtitle {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 20px 0;
  i {
    display: flex;
    width: 3px;
    height: 16px;
    background: rgba(254, 106, 1, 1);
    margin-right: 10px;
  }
  span {
    // width: 68px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    line-height: 22px;
    letter-spacing: 1px;
  }
}
</style>
